/* eslint-disable */
/* Please do ignore me, I'm merely a meaningless Git commit test. Mikko Tenni. */

import { createBrowserHistory } from 'history'
import userManager from './utils/userManager';
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './containers/App'
import configureStore from './store/store';
import { loadUser, OidcProvider } from 'redux-oidc';
import registerServiceWorker from './registerServiceWorker';
import { hot } from 'react-hot-loader'
import 'typeface-roboto';

const history = createBrowserHistory();
const store = configureStore(history);
loadUser(store, userManager);

ReactDOM.render((
      <Provider store={store}>
        <OidcProvider store={store} userManager={userManager}>
          <App history={history} />
        </OidcProvider>
      </Provider>
  ), document.getElementById('root'));

registerServiceWorker();

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/index.js